import React, { useEffect, useState } from "react";
import * as Styled from "./styled";

import { useDispatch, useSelector } from "react-redux";
import { fetchOwnedLands } from "../../../../reducers/hub";
import { isMobile } from "react-device-detect";

function MyLands(props) {
  const dispatch = useDispatch();

  const [landsIds] = useState(props.landsIds);
  const statedLands = useSelector((state) => state.hub.owned?.lands);
  const [lands, setLands] = useState(null);

  useEffect(() => {
    if (!statedLands) {
      dispatch(fetchOwnedLands(landsIds));
    } else if (isMobile && statedLands) {
      setLands(statedLands);
    }
  }, [dispatch, landsIds, props.isVisible, statedLands]);

  const handleCollapsedClick = () => {
    if (statedLands) setLands(statedLands);
    else dispatch(fetchOwnedLands(landsIds));
  };

  const handleLandSelect = (landId) => {
    props.onLandDetails(landId);
    setLands(null);
  };

  const handleClose = () => {
    setLands(null);
    props.onClose();
  };

  return (
    <Styled.Container>
      {lands ? (
        <Styled.ItemsContainer>
          <Styled.Expanded onClose={handleClose}>Your Lands</Styled.Expanded>
          <Styled.ScrollableContainer>
            {lands.map((land) => {
              return (
                <div key={land.id}>
                  <Styled.Item
                    isOpacity={land.meta === undefined}
                    zone={land.zone}
                    name={land.meta?.name ?? "Unnamed Land"}
                    description={land.meta?.description ?? "Edit your land’s details"}
                    onClickDetails={() => handleLandSelect(land.id)}
                  />
                  {land !== lands[lands.length - 1] && <Styled.Spacer />}
                </div>
              );
            })}
          </Styled.ScrollableContainer>
        </Styled.ItemsContainer>
      ) : (
        <Styled.Collapsed onClick={handleCollapsedClick} icon={require("./assets/ic-owned-lands.png")}>
          Your Lands
        </Styled.Collapsed>
      )}
    </Styled.Container>
  );
}

export default MyLands;
